import { useState, useEffect, useRef } from 'react';

export interface ToastProgressBarProps {
  autoClose?: number | false;
  closeToast?: () => void;
  progressClassName?: string;
  style?: React.CSSProperties;
}

export const ToastProgressBar: React.FC<ToastProgressBarProps> = ({
  autoClose = 5000,
  closeToast,
  progressClassName,
  style = {},
}) => {
  const [width, setWidth] = useState('100%');
  const duration = typeof autoClose === 'number' ? autoClose : 5000;
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setWidth('0%'));

    if (closeToast && duration) {
      timerRef.current = setTimeout(closeToast, duration);
    }
    return () => {
      cancelAnimationFrame(raf);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [duration, closeToast]);

  return (
    <div
      className={progressClassName}
      style={{
        position: 'absolute',
        right: 50,
        top: 25,
        height: '0.5rem',
        borderRadius: 10,
        width,
        transition: `width ${duration}ms linear`,
        ...style,
      }}
    />
  );
};
